import { useState } from "react";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";

const ForgotPasswordOTP = ({ handleCloseOTPModal, email }) => {
  const [otp, setOtp] = useState("");
  const [loader, setLoader] = useState(false);

  const handleResend = () => {
    //check if the user is not spamming this button
    if (loader) {
      return;
    }
    //add some delay to prevent spamming by checking the time difference
    if (
      localStorage.getItem("otpTime") &&
      localStorage.getItem("otpTime") > new Date().getTime() - 60000
    ) {
      toast.info("Please wait a minute before resending OTP");
      return;
    }

    setLoader(true);
    const forgotpassword = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/forget-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            role: "customer",
          }),
        }
      );
      const data = await res.json();
      setLoader(false);
      if (data.code === 200 && data.message === "Verify OTP") {
        localStorage.setItem("otpTime", new Date().getTime());
        toast.info("OTP has been sent to your email ID");
      }
    };
    forgotpassword();
  };

  const handleOTPSubmit = () => {
    const sendOTP = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/verify-forget-password-otp`,
        {
          method: "PUT",
          //add token to headers
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, otp }),
        }
      );
      const data = await response.json();
      if (data.code === 400) {
        toast.error("OTP is incorrect");
      } else if (data.code === 200) {
        toast.success("OTP is verified!");
        localStorage.removeItem("otpTime");
        const token = data.data.token;
        window.location.href = `/reset_password/?token=${token}`;
      }
    };
    sendOTP();
  };
  return (
    <div
      className={`fixed inset-0 z-50 $
     flex items-center justify-center" 
    backdrop-blur-[3px] bg-black bg-opacity-20`}
    >
      <div className="flex flex-col items-center justify-center bg-white rounded-md sm:p-12 p-8 mx-auto">
        <div className="flex flex-row-reverse items-center justify-between w-full relative sm:bottom-10 bottom-5">
          {/* <AiOutlineClose
            className="text-primaryGreen cursor-pointer relative sm:left-9 left-5"
            size={30}
            onClick={handleCloseOTPModal}
          /> */}
        </div>
        <h3 className="text-3xl text-center mb-5">
          Enter One Time Password (OTP)
        </h3>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          required
          inputStyle={{
            border: "2px solid #F66",
            borderRadius: 5,
            width: 40,
            height: 50,
            margin: 3,
            textAlign: "center",
            fontSize: 20,
            fontWeight: "bold",
            color: "#F66",
          }}
          renderSeparator={<span style={{ color: "#F66" }}>-</span>}
          renderInput={(props) => <input {...props} />}
          shouldAutoFocus
          placeholder="XXXXXX"
        />
        <div className="flex items-center justify-center gap-2">
          <button
            className="py-3 px-10 mt-5 border-2 bg-[#F66] text-white duration-150 ease-linear rounded-md hover:bg-primary-dark"
            onClick={handleResend}
          >
            Resend
          </button>
          <button
            className="py-3 px-10 mt-5 border-2 border-[#F66] text-black duration-150 ease-linear rounded-md hover:bg-primary-dark"
            onClick={handleOTPSubmit}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordOTP;
